
export interface IActionParameter {
    name: string,
    type: string,
    label: string,
    isRequired: boolean,
    enumerationCode?: string,
    options?: {value: string, name: string}[],

    value: any,
}

export interface IFeatureParameter {
    name: string,
    type: string,
    label: string,
    isRequired: boolean,
    enumerationCode?: string,
    options?: {value: string, name: string}[],

    value: any,
}

export interface IEntityAction {
    objectDataDef?: string,
    objectKey?: string,

    name?: string,
    caption?: string,
    saveBeforeAction?: boolean,
    params: IActionParameter[]
}

export const defaultEntityAction: IEntityAction = {
    params: [],
}


export interface IReportEdition {
    objectDataDef?: string,
    objectKey?: string,

    reportLayoutName?: string,
    reportLayoutID: number,
    objectEditionID: number,

    editionType?: string,
    routine?: string, 

    saveBeforeAction?: boolean,
    params: IActionParameter[]
}

export interface IPdfFile {
    urlPdf: string,
    fileName: string,
}

export interface ITemplateDocument {
    objectDataDef?: string,
    objectKey?: string,

    docReference?: string,
    documentCode: string,
    
}